import client from "@irati/utils/services/apollo"
import PBService from "@irati/utils/services"

import {MfaTotpSetup, MfaTotpUser} from "@irati/types"
import mfa from "../utils/mfa"
import mfaService from "./mfa"
import mfaGetTotpUserQuery, {mfaTotpGetUserKey} from "./queries/mfaGetTotpUser"
import mfaTotpSetupMutation, {mfaTotpSetupKey} from "./mutations/mfaTotpSetup"
import mfaTotpValidateMutation, {mfaTotpValidateKey} from "./mutations/mfaTotpValidate"
import mfaTotpDeleteUserMutation, {mfaTotpDeleteUserKey} from "./mutations/mfaTotpDeleteUser"
import mfaErrorHandler from "./errors/mfaErrorHandler"
import tokens from "./tokens"

class MFATotp extends PBService {
  async hasFlag(): Promise<boolean> {
    return mfaService.hasFlag()
  }

  async getUser(userId?: string): Promise<MfaTotpUser | null> {
    const variables = {userId}
    const {data} = await client.query({query: mfaGetTotpUserQuery, variables, fetchPolicy: "network-only"})
    return data[mfaTotpGetUserKey]
  }

  async setup(): Promise<MfaTotpSetup> {
    const {data} = await client.mutate({mutation: mfaTotpSetupMutation})
    return data[mfaTotpSetupKey]
  }

  async validate(passcode: string): Promise<boolean> {
    const variables = {passcode}
    try {
      const {data} = await client.mutate({mutation: mfaTotpValidateMutation, variables})
      const {success, accessToken} = data[mfaTotpValidateKey]
      await tokens.replace({accessToken})
      mfa.complete()
      return success
    } catch (e) {
      throw e
    }
  }

  async deleteUser(userId: string): Promise<boolean> {
    const variables = {userId}
    const {data} = await client.mutate({mutation: mfaTotpDeleteUserMutation, variables, fetchPolicy: "no-cache"})
    return data[mfaTotpDeleteUserKey]
  }
}

const mfaTotpService = new MFATotp({errorHandlers: [mfaErrorHandler]})

export default mfaTotpService
